

  import {Component, Prop, Vue} from "vue-property-decorator";
  import XLSX, {WritingOptions} from "xlsx";
  import $ from 'jquery'

  @Component({name:'ExportTableHtml'})
  export default class ExportTableHtml extends Vue{

    @Prop({required:true})
    tableId!:string;

    @Prop({required:true})
    fileName!:string;

    @Prop({required:false})
    beforeWrite?:Function;

    loading:boolean = false;

    handleExport(){

      this.loading = true;
      if(this.beforeWrite && typeof this.beforeWrite === 'function'){

        const fnResult = this.beforeWrite() as Promise<void>;
        if(fnResult){
          fnResult.then(()=>{
            this.export();
          })
        } else {
          this.export();

        }
      } else {
        this.export();
      }


    }

    export(){
      let tableElement = document.querySelector('#'+this.tableId);

      if(!tableElement || tableElement.tagName!=='TABLE'){
        tableElement = document.querySelector('#'+this.tableId +' table');
      }

      this.replaceToNumber(tableElement)

      const wb  = XLSX.utils.table_to_book(tableElement,{});
      XLSX.writeFile(wb,this.fileName+'.xlsx');
      this.loading = false;
      this.restoreNumberText(tableElement)
    }


    replaceToNumber(tableElement:any){
      const $table = $(tableElement);
      $table.find('tbody tr td').each((i,td)=>{
        const $td = $(td);
        let numberText = $td.text();
        $td.text(numberText.replace('\'','')).attr('data-number',numberText)
      })
    }

    restoreNumberText(tableElement:any){
      const $table = $(tableElement);
      $table.find('tbody tr td').each((i,td)=>{
        const $td = $(td);
        $td.text($td.attr('data-number')!.trim())
      })
    }
  }

